import { CustomTag } from "@cleanup/components/TagMore";

interface UserTagProps {
  tagName: string;
  className?: string;
}

export const UserPendingTag: React.FC<UserTagProps> = ({
  tagName,
  className,
}) => {
  return (
    <CustomTag
      className={className}
      bg="#ffffff"
      color="#000000"
      border="1px solid #b8bfca"
      tagName={tagName}
    />
  );
};

export const UserExpiredTag: React.FC<UserTagProps> = ({
  tagName,
  className,
}) => {
  return (
    <CustomTag
      className={className}
      bg="#ffcc66"
      color="#fff"
      tagName={tagName}
    />
  );
};

export const UserBouncedTag: React.FC<UserTagProps> = ({
  tagName,
  className,
}) => {
  return (
    <CustomTag
      className={className}
      bg="#fdd259"
      color="#000000"
      tagName={tagName}
    />
  );
};
